import {
	formatAddressLabel,
	formatAddressTitle,
	normalizeBranchText,
} from '@/modules/Home/components/Hero/DeliveryBar/utils';

const parseDateParts = (dateStr) => {
	const [year, month, day] = dateStr.split('-').map(Number);
	if (!year || !month || !day) return null;
	return new Date(year, month - 1, day);
};

const isSameDay = (a, b) =>
	a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export const formatScheduledDateLabel = (dateStr, { translate, locale = 'en' }) => {
	if (!dateStr) return null;

	try {
		const date = parseDateParts(dateStr);
		if (!date) return dateStr;

		const today = new Date();
		if (isSameDay(date, today)) return translate('fulfillmentChips.today');

		const tomorrow = new Date(today);
		tomorrow.setDate(today.getDate() + 1);
		if (isSameDay(date, tomorrow)) return translate('fulfillmentChips.tomorrow');

		const localeMap = { en: 'en-US', hy: 'hy-AM', ru: 'ru-RU' };
		return date.toLocaleDateString(localeMap[locale] || locale, { month: 'short', day: 'numeric' });
	} catch {
		return dateStr;
	}
};

const buildScheduleLine = (checkoutData, translate, locale) => {
	if (checkoutData?.fulfillmentType === 'asap') return translate('fulfillmentChips.asap');
	if (!checkoutData?.scheduledDate || !checkoutData?.scheduledTime) return null;

	const dateLabel = formatScheduledDateLabel(checkoutData.scheduledDate, { translate, locale });
	if (!dateLabel) return null;

	return `${dateLabel} | ${checkoutData.scheduledTime}`;
};

export const buildFulfillmentCheckoutDisplay = ({
	checkoutData,
	selectedAddress,
	selectedBranch,
	phone,
	translate,
	locale,
}) => {
	const isTakeaway = checkoutData?.fulfillmentType === 'takeaway';
	const scheduleLine = buildScheduleLine(checkoutData, translate, locale);
	const phoneLine = phone ? String(phone).trim() : null;

	let displayLines = [];

	if (isTakeaway) {
		if (selectedBranch) {
			displayLines = [
				normalizeBranchText(selectedBranch.name),
				normalizeBranchText(selectedBranch.address),
				scheduleLine,
				phoneLine,
			].filter(Boolean);
		}
	} else if (selectedAddress) {
		const title = formatAddressTitle(selectedAddress);
		const addressLine = formatAddressLabel(selectedAddress);

		displayLines = [title, addressLine !== title ? addressLine : null, scheduleLine, phoneLine].filter(Boolean);
	}

	return {
		titleKey: isTakeaway
			? 'checkoutFulfillment.takeawayInfoTitle'
			: 'checkoutFulfillment.deliveryInfoTitle',
		footerKey: isTakeaway
			? 'checkoutFulfillment.defaultPickupLocation'
			: selectedAddress?.is_default
				? 'account.address_management.defaultShippingAddress'
				: null,
		displayLines,
		isTakeaway,
		hasContent: displayLines.length > 0,
	};
};
